class MobileNav {
  constructor() {
    const $body = $('body');
    this.scopeRole = {
      mobileNav: '.menu-mobile__container',
      mobileTrigger: '[data-role="mobile-nav-trigger"]',
      submenuToggle: '[data-submenu-toggle]',
      submenuBack: '[data-submenu-back]',
    };
    this.scopeStyle = {
      closed: 'burger-menu-closed',
      opened: 'burger-menu-opened',
    }
    this.mql = window.matchMedia('(min-width: 1280px)')

    // Main Nav
    this.$mobilenav = $body.find(this.scopeRole.mobileNav)
    this.$mobileTrigger = $body.find(this.scopeRole.mobileTrigger)

    // Sub menu
    this.$submenuToggles = this.$mobilenav.find(this.scopeRole.submenuToggle)
    this.$submenuBacks = this.$mobilenav.find(this.scopeRole.submenuBack)

    // Bindings
    this.handleToggleMenu = this.handleToggleMenu.bind(this)
    this.openSubmenu = this.openSubmenu.bind(this)
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this)
  
    if (this.$mobilenav.length) {
      this.initialize()
    }
  }

  handleToggleMenu() {
    if (this.$mobileTrigger.hasClass(this.scopeStyle.closed)) {
      this.open()
    } else {
      this.close()
    }
  }

  close() {
    this.$mobileTrigger
      .removeClass(this.scopeStyle.opened)
      .removeClass('active')
      .addClass(this.scopeStyle.closed)
    this.$mobilenav.removeClass('active')
    $('html').removeClass('menu-open')

    // Close all submenus
    this.$mobilenav.find('[data-submenu]').removeClass('active')
    this.$mobilenav.removeClass('overflow-hidden')

    // Close lang dropdown
    this.$mobilenav.find('.dropdown__container').removeClass('open')
  }

  open() {
    this.$mobileTrigger
      .removeClass(this.scopeStyle.closed)
      .addClass(this.scopeStyle.opened)
      .addClass('active')
    this.$mobilenav.addClass('active')
    $('html').addClass('menu-open')
  }

  openSubmenu(e) {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $submenu = $target.next()
    
    if (!$submenu) return

    $submenu.addClass('active')
    this.$mobilenav.addClass('overflow-hidden')
  }

  closeSubmenu(e) {
    e.preventDefault()
    const $target = $(e.currentTarget)
    const $submenu = $target.closest('[data-submenu]')

    if (!$submenu) return

    $submenu.removeClass('active')
    this.$mobilenav.removeClass('overflow-hidden')
  }


  handleBreakpointChange() {
    if (this.mql.matches) {
      this.close()
    }
  }

  initialize() {
    this.handleBreakpointChange()
    this.$mobileTrigger.on('click', this.handleToggleMenu)
    this.$submenuToggles.on('click', this.openSubmenu)
    this.$submenuBacks.on('click', this.closeSubmenu)
    this.mql.addEventListener('change', this.handleBreakpointChange)
  }

}

export default MobileNav



// WEBPACK FOOTER //
// ./scripts/navigation/MobileNav.js